/**
 * Application-wide constants
 */

/**
 * Message input limits for chat interface
 */
export const MESSAGE_LIMITS = {
  /** Maximum allowed character length for a single message */
  MAX_LENGTH: 4000,

  /** Threshold at which to show warning (90% of max) */
  WARNING_THRESHOLD: 3600,

  /** Threshold at which to show soft warning (80% of max) */
  SOFT_WARNING: 3200,
} as const;

/**
 * Conversation limits
 */
export const CONVERSATION_LIMITS = {
  /** Maximum number of active conversations to keep */
  MAX_ACTIVE: 20,
} as const;

/**
 * Rate limiting constants
 * Note: These are fallback/client-side hints. Server-side rate limits are enforced via database.
 */
export const RATE_LIMITS = {
  /** Minimum milliseconds between messages */
  MIN_INTERVAL: 2000,

  /** Maximum messages in burst window */
  BURST_LIMIT: 5,

  /** Burst window duration in milliseconds */
  BURST_WINDOW: 30000,
} as const;

/**
 * Plan-based rate limit defaults (mirrored from database for UI display)
 * These match the values in supabase/migrations/20260101000100_chat_rate_limits.sql
 */
export const PLAN_RATE_LIMITS = {
  free: {
    perMinute: 3,
    perHour: 15,
    perDay: 30,
    monthly: 100,
  },
  growth: {
    perMinute: 5,
    perHour: 50,
    perDay: 150,
    monthly: 1500,
  },
  pro: {
    perMinute: 10,
    perHour: 200,
    perDay: 500,
    monthly: -1, // unlimited
  },
  agency: {
    perMinute: 15,
    perHour: -1, // unlimited
    perDay: -1, // unlimited
    monthly: -1, // unlimited
  },
} as const;
